<div class="platform-icons">
  @if (!hasPlatforms) {
    <img class="platform-icon" width="16" height="16" [src]="globeIcon | assetVersion" alt="all platforms">
  }
  @for (platform of platforms; track platform) {
    @if (getIconSrc(platform); as src) {
      <img class="platform-icon" width="16" height="16" [src]="src | assetVersion" [alt]="platform">
    }
  }
</div>
